import { AuthenticationService } from 'app/servicios';
import  Utils  from 'app/shared/utilerias/utils';
import { CatUsuarios } from './../../entidades/entidades';
import { CatNivelSeguridadesService } from './../../servicios/cat-nivel-seguridades.service';
import { Component, OnInit, ViewChild, ElementRef, ɵConsole } from '@angular/core';
import { CatUsuariosService } from 'app/servicios/cat-usuarios.service';
import { Router } from '@angular/router';
import {  Privilegios } from 'app/entidades/entidades';

@Component({
  selector: 'app-quejas',
  templateUrl: './quejas.component.html',
  styleUrls: ['./quejas.component.css']
})
export class QuejasComponent implements OnInit {

  usuario: any ;
  idNivel: number;
  constructor(
    private router: Router,
    private catNivelSeguridadesService:CatNivelSeguridadesService,
    private authentication:AuthenticationService) {
    
   }
  @ViewChild('divLectura') divLectura: ElementRef;
  
  lectura:boolean=false;

  async  ngOnInit() 
  {
    
    await this.authentication.getUserByToken();
    this.usuario = this.authentication.currentUserValue;
     
  
    let objUrl = new Privilegios();
    objUrl.descripcion = this.router.url;
    var objNivelSeg = await this.catNivelSeguridadesService.GetNivelPorPrivilegio(objUrl).toPromise();
    if (objNivelSeg[0]!=undefined){
          this.idNivel = (objNivelSeg[0]).id;
         
    }
    //solo lectura.

    // if (this.idNivel==1)
    //   this.divLectura.nativeElement.style = "pointer-events: none";
    // else if (this.idNivel>1)
    //   this.divLectura.nativeElement.style = "pointer-events: auto";


  }



  
}
